import {connect} from 'react-redux';

import Actions from '@/Actions';
import UI from './TestUI';

const calculateTotalPoints = (totalPoints, question) => {
    if (question.questions) return question.questions.reduce(calculateTotalPoints, totalPoints);
    return totalPoints += question.points;
};

const calculateActualPoints = scores => scores.reduce((sum, entry) => sum + (parseInt(entry[1]) || 0), 0);

const isWaitingForGrade = (scores, answers) => {
    if (!scores.length) return true;
    if (scores.length !== answers.length) return true;

    for (var i = 0; i < scores.length; i++) {
        if (scores[i][1] === null) return true;
    }
};

const mapStateToProps = (state, ownProps) => {
    let questions = state.app.content.questions || [];
    let values = state.app.testForm?.values ?? {};
    let errors = state.app.submit_errors;

    let props = {
        questions: questions,
        formValues: values,
        submitErrors: errors ? errors : undefined,
        isPreview: state.app.preview_mode,
    };

    if (state.app.section.preset === 'test_results') {
        let usersResponse = state.app.users_response || [];
        let scores = Object.entries(usersResponse).filter(entry => entry[0].startsWith('score_'));
        let answers = Object.entries(usersResponse).filter(entry => entry[0].startsWith('question_'));
        if (!isWaitingForGrade(scores, answers)) props.actualPoints = calculateActualPoints(scores);
        props.possiblePoints = questions.reduce(calculateTotalPoints, 0);
        props.isTestResults = true;
    }

    return props;
};

const mapDispatchToProps = (dispatch) => {
    return {
        onAutoSave: (formData, onSuccess, onFailure) => {
            dispatch(Actions.save(formData, onSuccess, onFailure));
        },
        onSubmit: (formData) => dispatch(Actions.submit(formData)),
        onFormUpdate: (formData) => dispatch(Actions.setFormData(formData)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(UI);
